<template>
	<div>
		<div v-if="mode === 'list'">
			<div class="table-schedule" frame="void" id="private_table">
				<div class="table-top">
					<div class="table-td">
						{{ translations.captions.fundName }}
					</div>

					<div class="table-td table-pointer" @click="ChangeSort('fund_created')">
						<div class="sort-by">
							<a class="arrows-down" :class="{ active: currentOrderField === 'fund_created' && currentOrderDirection === 'asc' }"></a>
							<a class="arrows-up" :class="{ active: currentOrderField === 'fund_created' && currentOrderDirection === 'desc' }"></a>
						</div>
						{{ translations.tableCaptions.age }}
					</div>

					<div class="table-td table-pointer" @click="ChangeSort('assets_size')">
						<div class="sort-by">
							<a class="arrows-down" :class="{ active: currentOrderField === 'assets_size' && currentOrderDirection === 'asc' }"></a>
							<a class="arrows-up" :class="{ active: currentOrderField === 'assets_size' && currentOrderDirection === 'desc' }"></a>
						</div>
						{{ translations.tableCaptions.assets }}
					</div>

					<!-- div class="table-td table-pointer" @click="ChangeSort('participates');">
						<div class="sort-by">
							<a class="arrows-down "
							   :class="{'active': (currentOrderField==='participates' && currentOrderDirection==='asc')}"></a>
							<a class="arrows-up "
							   :class="{'active': (currentOrderField==='participates' && currentOrderDirection==='desc')}"></a>
						</div>
						{{ translations.tableCaptions.numberOfInvestors }}
					</div -->

					<div class="table-td table-pointer" @click="ChangeSort('profitability')">
						<div class="sort-by">
							<a class="arrows-down " :class="{ active: currentOrderField === 'profitability' && currentOrderDirection === 'asc' }"></a>
							<a class="arrows-up " :class="{ active: currentOrderField === 'profitability' && currentOrderDirection === 'desc' }"></a>
						</div>
						{{ translations.tableCaptions.profitable }}
					</div>

					<div class="table-td">
						{{ translations.tableCaptions.chart }}
					</div>

					<div class="table-td">
						&nbsp;
					</div>
				</div>

				<div v-for="(fund, index) in fundsData">
					<div v-if="fund.profitability > 0" :class="{ active: fund.showchart }" class="table-line" @click="ToggleChart(index)">
						<div class="table-td">{{ fund.caption }}</div>

						<div class="table-td" :title="fund.fund_created">{{ ParseDateAgoLite(fund.fund_created) }}</div>

						<div class="table-td" data-value="783">
							<float-currency :value="fund.assets_size || 0" :currency="fund.currency"></float-currency>
						</div>

						<!-- div class="table-td">{{ fund.participates }}</div -->

						<div
							class="table-td"
							:class="{ 'red-text': displayProfitabilityValue(fund.profitability) < 0, 'green-text': displayProfitabilityValue(fund.profitability) >= 0 }"
						>
							<float-currency :value="fund.profitability || 0" :currency="'%'"></float-currency>
						</div>

						<div class="table-td">
							<div class="mini-graf" :id="'inline-chart-' + fund.lk_id"></div>
						</div>

						<div class="table-td">
							<a :href="'https://my.forexchief.com/en/investments/funds/?f=' + fund.lk_id" class="back-button invest_btn" target="_blank"
								>{{ translations.buttons.invest }}
							</a>
						</div>
					</div>
					<div class="hidden-container" :id="'hidden-holder-' + fund.lk_id" v-show="fund.showchart">
						<div :id="'sub-hidden-holder-' + index" v-click-outside:CloseOpenedGraph="index">
							<div class="hidden-graf" :id="'hidden-chart-' + fund.lk_id"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import FloatCurrency from "@/components/floatCurrency";
import DeclarationText from "@/components/declarationText";

export default {
	name: "list.funds.component.vue",
	components: { DeclarationText, FloatCurrency },
	data() {
		return {
			/* eslint no-undef: 2 */
			translations: translations,
			isInRequest: false,
			/**
			 * Флаг, находится ли скрипт в состоянии запроса на пополнение
			 */
			isInDepositRequest: false,
			isSuccess: null,
			isDepositSuccess: false,
			mode: "list",
			/**
			 * Находится ли приложение в тестовом режиме.
			 * В нем будут спрятаны некоторые кнопки для не админов
			 */
			// isInTestMode: false,
			activationModalShow: false,
			currentOrderField: "assets_size",
			currentOrderDirection: "desc",
			// defaultFundActivation: activationFund,
			// defaultFundManage: manageFund,
			/**
			 * Типы счетов
			 */
			accountTypes: [
				{ value: 15001, bitrix: 1291579, name: "pamm-MT4.DirectFX" },
				{ value: 15002, bitrix: 1291581, name: "pamm-MT4.Classic+" },
				{ value: 15003, bitrix: 1291582, name: "pamm-MT5.DirectFX" },
				{ value: 15004, bitrix: 1291585, name: "pamm-MT5.Classic+" },
			],
			/**
			 * Список фондов
			 */
			fundsData: [],
			/**
			 * Данные выбранного фонда
			 */
			fundData: {
				fund: {
					caption: "",
					currency: "USD",
					assets_size: 0,
					reward_revolve: 1,
					fund_type: 0,
					declaration: "",
					account_type: 0,
					reward: 0,
					charge_min: 100,
					charge_min_caption: "100.00",
					minimalActivationDeposit: 100,
					minimalActivationDepositCaption: "100.00",
				},
				account: {},
			},
			/**
			 * Форма редактирования. ID фонда
			 */
			formFundId: 0,
			/**
			 * Форма редактирования. Название фонда
			 */
			formFundName: "",
			/**
			 * Форма редактирования. Тип фонда
			 */
			formFundType: 0,
			/**
			 * Форма редактирования. Декларация фонда
			 */
			formFundDeclaration: "",
			/**
			 * Форма редактирования. Период выплаты вознаграждения
			 */
			formInterestPaymentPeriod: 1,
			formAccountType: 1,
			formAccountCurrency: "USD",
			formManagersReward: 5,
			formInvestmentAmount: 100,
			formFundAccount: 0,
			errors: {
				fundName: "",
				fundDeclaration: "",
			},
			depositFormAmount: 0,
			depositFormAccount: "",
			depositFormAccountCurrency: "",
			depositFormWithdrawAmount: 0,
			depositFormWithdrawRate: 1,
			accountsData: [],
			depositFormAmountError: false,
			depositFormAmountInsufficientError: false,
			/**
			 * Баланс лицевого счета
			 */
			personalAccountBalance: 0,
			modalCanBeClosed: false,
			isClosing: false,
			/**
			 * Сколько записей будет отображаться на странице
			 */
			recordsPerPage: 20,
			/**
			 * Всего страниц в таблице
			 */
			totalPages: 1,
		};
	},
	mounted() {
		this.mode = "list";

		this.GetList();
	},
	computed: {
		currentPage() {
			return this.$store.state.currentPage;
		},
	},
	methods: {
		OpenDetail(fundId) {
			location.href = "https://my.forexchief.com/en/investments/funds/?f=" + fundId;
		},
		displayProfitabilityValue(floatValue) {
			let result = "0";
			if (floatValue !== null) {
				result = new Intl.NumberFormat("ru-RU", { style: "decimal", maximumFractionDigits: 2 }).format(parseFloat(floatValue));
			}

			return result.replace(",", ".");
		},

		/**
		 * Закрытие графика при клике мимо него
		 */
		CloseOpenedGraph(index) {
			if (this.isClosing) {
				return;
			}

			this.isClosing = true;

			let object = this.fundsData[index];

			if (typeof object.clickCount !== "undefined" && object.clickCount <= 1) {
				object.showchart = false;
				object.clickCount = 0;

				this.$forceUpdate();
			} else {
				try {
					object.clickCount--;
				} catch (ex) {
					object["clickCount"] = 0;
					this.fundData[index] = object;
				}

				this.$forceUpdate();
			}

			this.isClosing = false;
		},

		/**
		 * Отработка события изменения текущей страницы
		 */
		ChangePage: function() {
			this.GetList();
		},

		/**
		 * Постановка очереди загрузки графиков
		 * @constructor
		 */
		InlineGraphQueue() {
			let self = this;
			// console.log('Inline');

			let multipler = 200;
			for (let counter = 0; counter < self.fundsData.length; counter++) {
				let currentFund = self.fundsData[counter].lk_id;
				setTimeout(function() {
					self.InlineGraphLoader(currentFund);
				}, counter * multipler);
			}
		},
		/**
		 * Загрузка данных для графика
		 * @param fundId
		 * @constructor
		 */
		InlineGraphLoader(fundId) {
			let self = this;
			let holder = document.getElementById("inline-chart-" + fundId);
			if (holder === null) {
				return;
			}
			holder.innerHTML = "";
			let container = holder;

			let width = 90;
			let height = 30;

			var chart = LightweightCharts.createChart(container, {
				width: 90,
				height: 30,
				rightPriceScale: {
					visible: false,
				},
				leftPriceScale: {
					visible: false,
				},
				timeScale: {
					visible: false,
				},
				crosshair: {
					horzLine: {
						visible: false,
					},
					vertLine: {
						visible: false,
					},
				},
				layout: {
					backgroundColor: "transparent",
				},
				grid: {
					vertLines: {
						color: "transparent",
					},
					horzLines: {
						color: "transparent   ",
					},
				},
			});

			var areaSeries = chart.addAreaSeries({
				symbol: "AAPL",
				topColor: "rgba(76, 175, 80, 0.5)",
				lineColor: "rgba(76, 175, 80, 1)",
				bottomColor: "rgba(76, 175, 80, 0)",
				lineWidth: 1,
			});

			axios
				.get("/service/ajax/site/getFundYield.php", {
					params: {
						id: fundId,
						period: "all",
						limit: 180,
					},
					headers: {
						Authorization: "Bearer: " + window.API_TOKEN_KEY,
					},
				})
				.then(function(response) {
					areaSeries.setData(response.data.data);

					let dayData = response.data.data;
					let weekData = response.data.data;
					let monthData = response.data.data;
					let yearData = response.data.data;
					let allData = response.data.data;

					let seriesesData = new Map([
						[translations.chartCaptions.intervalDay, dayData],
						[translations.chartCaptions.intervalWeek, weekData],
						[translations.chartCaptions.intervalMonth, monthData],
						[translations.chartCaptions.intervalYear, yearData],
						[translations.chartCaptions.intervalAll, allData],
					]);

					function createSimpleSwitcher(items, activeItem, activeItemChangedCallback) {
						var switcherElement = document.createElement("div");
						switcherElement.classList.add("switcher");

						var intervalElements = items.map(function(item) {
							var itemEl = document.createElement("button");
							itemEl.innerText = item;
							itemEl.classList.add("switcher-item");
							itemEl.classList.toggle("switcher-active-item", item === activeItem);
							itemEl.addEventListener("click", function() {
								onItemClicked(item);
							});
							switcherElement.appendChild(itemEl);
							return itemEl;
						});

						function onItemClicked(item) {
							if (item === activeItem) {
								return;
							}

							intervalElements.forEach(function(element, index) {
								element.classList.toggle("switcher-active-item", items[index] === item);
							});

							activeItem = item;

							activeItemChangedCallback(item);
						}

						return switcherElement;
					}

					let intervals = [
						translations.chartCaptions.intervalDay,
						translations.chartCaptions.intervalWeek,
						translations.chartCaptions.intervalMonth,
						translations.chartCaptions.intervalYear,
						translations.chartCaptions.intervalAll,
					];

					let switcherElement = createSimpleSwitcher(intervals, intervals[4], syncToInterval);

					let chartElement = document.createElement("div");
					const width = 860;
					const height = 380;

					let formatters = {
						Dollar: function(price) {
							let currencySymbol = "";
							if (price >= 0) {
								return currencySymbol + price.toFixed(2);
							} else {
								return "-" + currencySymbol + (price * -1).toFixed(2);
							}
						},
						Euro: function(price) {
							let currencySymbol = "";
							if (price >= 0) {
								return currencySymbol + price.toFixed(2);
							} else {
								return "-" + currencySymbol + (price * -1).toFixed(2);
							}
						},
					};

					const formatterNames = Object.keys(formatters);

					let hiddenChart = LightweightCharts.createChart(chartElement, {
						width: width,
						height: height,
						layout: {
							backgroundColor: "white",
							textColor: "black",
						},
						localization: {
							priceFormatter: formatters[formatterNames[0]],
						},
						grid: {
							vertLines: {
								visible: false,
								labelVisible: true,
								color: "rgba(42, 46, 57, 0.5)",
							},
						},
						crosshair: {
							horzLine: {
								visible: false,
							},
						},
						rightPriceScale: {
							visible: false,
						},
						leftPriceScale: {
							visible: true,
						},
						timeScale: {
							timeVisible: true,
							secondsVisible: false,
						},
					});

					let hiddenHolder = document.getElementById("hidden-chart-" + fundId);
					hiddenHolder.innerHTML = "";
					hiddenHolder.appendChild(switcherElement);
					hiddenHolder.appendChild(chartElement);

					let hiddenAreaSeries = null;

					function businessDayToString(businessDay) {
						return businessDay.date.getFullYear() + "-" + businessDay.getMonth() + "-" + businessDay.getDate();
					}

					let toolTipWidth = 80;
					let toolTipHeight = 80;
					let toolTipMargin = 15;

					let toolTip = document.createElement("div");
					toolTip.className = "floating-tooltip-2";
					hiddenHolder.appendChild(toolTip);

					// region Обработчик передвижения курсора по графику

					hiddenChart.subscribeCrosshairMove(function(param) {
						if (
							param.point === undefined ||
							!param.time ||
							param.point.x < 0 ||
							param.point.x > chartElement.clientWidth ||
							param.point.y < 0 ||
							param.point.y > chartElement.clientHeight
						) {
							toolTip.style.display = "none";
						} else {
							const date = new Date((parseInt(param.time) - 3600 * 3) * 1000);

							let dateStr = self.ParseDateFull(
								date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
							);

							toolTip.style.display = "block";
							let price = param.seriesPrices.get(hiddenAreaSeries);
							toolTip.innerHTML =
								'<div style="color: #009688">' +
								graphValueCaption +
								'</div><div style="font-size: 24px; margin: 4px 0px; color: #21384d">' +
								Math.round(100 * price) / 100 +
								'%</div><div style="color: #21384d">' +
								dateStr +
								"</div>";
							let coordinate = hiddenAreaSeries.priceToCoordinate(price);
							let shiftedCoordinate = param.point.x - 50;

							if (coordinate === null) {
								return;
							}

							shiftedCoordinate = Math.max(0, Math.min(chartElement.clientWidth - toolTipWidth, shiftedCoordinate));

							let coordinateY =
								coordinate - toolTipHeight - toolTipMargin > 0
									? coordinate - toolTipHeight - toolTipMargin
									: Math.max(0, Math.min(chartElement.clientHeight - toolTipHeight - toolTipMargin, coordinate + toolTipMargin));

							toolTip.style.left = shiftedCoordinate + "px";
							toolTip.style.top = coordinateY + "px";
						}
					});

					// endregion

					/**
					 * Синхронизация с интервалом, что бы это ни значило
					 * @param interval
					 */
					function syncToInterval(interval) {
						if (hiddenAreaSeries) {
							hiddenChart.removeSeries(hiddenAreaSeries);
							hiddenAreaSeries = null;
						}

						hiddenAreaSeries = hiddenChart.addAreaSeries({
							symbol: "AAPL",
							topColor: "rgba(76, 175, 80, 0.5)",
							lineColor: "rgba(76, 175, 80, 1)",
							bottomColor: "rgba(76, 175, 80, 0)",
							lineWidth: 1,
						});

						let period = "month";
						switch (interval) {
							case translations.chartCaptions.intervalWeek:
								period = "week";
								break;
							case translations.chartCaptions.intervalMonth:
								period = "month";
								break;
							case translations.chartCaptions.intervalYear:
								period = "year";
								break;
							case translations.chartCaptions.intervalAll:
								period = "all";
								break;
							default:
								// case '1 год':
								period = "day";
								break;
						}

						axios
							.get("/service/ajax/site/getFundYield.php", {
								params: {
									id: fundId,
									period: period,
								},
								headers: {
									Authorization: "Bearer: " + window.API_TOKEN_KEY,
								},
							})
							.then(function(response) {
								response.data.data;

								hiddenAreaSeries.setData(response.data.data);

								hiddenChart.timeScale().fitContent();
							});
					}

					syncToInterval(intervals[4]);

					chart.timeScale().fitContent();
				})
				.catch(function(e) {
					// self.isSuccess = false;
				});
		},
		/**
		 * Переключение видимости большого графика
		 * @constructor
		 * @param index
		 */
		ToggleChart(index) {
			let self = this;
			this.isClosing = true;

			let object = this.fundsData[index];

			if (typeof object.showchart === "undefined") {
				object["showchart"] = false;
			}

			if (typeof object.clickCount === "undefined") {
				object["clickCount"] = 2;
			}

			object.showchart = !object.showchart;

			if (object.showchart) {
				object.clickCount = 2;
			} else {
				object.clickCount = 0;
			}

			this.fundsData[index] = object;

			this.$forceUpdate();
			this.isClosing = false;
		},

		ChangeSort(field) {
			this.currentOrderField = field;
			if (this.currentOrderDirection === "asc") {
				this.currentOrderDirection = "desc";
			} else {
				this.currentOrderDirection = "asc";
			}

			this.GetList();
		},
		/**
		 * Парсер даты в полной формате
		 */
		ParseDateFull(value) {
			const currentDate = new Date(value);
			return moment(currentDate).format("DD.MM.Y HH:mm");
		},
		/**
		 * Парсер даты "сколько-то дней назад"
		 * @param {string} value Дата
		 * @return {*}
		 * @constructor
		 */
		ParseDateAgo(value) {
			const currentDate = moment.tz(value, "GMT");
			return currentDate.fromNow();
		},
		/**
		 * Парсер даты "сколько то дней" без "назад"
		 * @param value
		 * @constructor
		 */
		ParseDateAgoLite(value) {
			const now = moment();
			const currentDate = moment.tz(value, "GMT");

			let years = now.diff(currentDate, "years");
			let months = now.diff(currentDate, "months");
			if (years >= 1) {
				months = months - years * 12;
			}
			let days = now.diff(currentDate, "days");

			if (months >= 1) {
				days = days - now.diff(currentDate, "months") * 30;
			}

			if (years >= 1) {
				if (months >= 1) {
					return years + " " + this.translations.captions.momentYears + " " + months + " " + this.translations.captions.momentMonths;
				}

				return years + " " + this.translations.captions.momentYears;
			}

			if (months >= 1) {
				if (days >= 1 && days !== 32) {
					return months + " " + this.translations.captions.momentMonths + " " + days + " " + this.translations.captions.momentDays;
				} else if (days >= 1 && days === 32) {
					return ++months + " " + this.translations.captions.momentMonths;
				}
				return months + " " + this.translations.captions.momentMonths;
			}

			return days + " " + this.translations.captions.momentDays;
		},
		GetList() {
			var self = this;
			if (this.isInRequest) {
				return;
			}

			axios
				.get("/service/ajax/site/getFunds.php", {
					params: {
						sort: self.currentOrderField,
						order: self.currentOrderDirection,
						page: self.$store.state.currentPage,
						rows: self.recordsPerPage,
					},
					headers: {
						Authorization: "Bearer " + window.API_TOKEN_KEY,
					},
				})
				.then(function(data) {
					self.fundsData = data.data.data;

					if (self.fundsData.length > 0) {
						self.totalPages = Math.ceil(parseInt(data.data.total) / self.recordsPerPage);
						self.InlineGraphQueue();
					}
				})
				.catch(function(e) {
					self.isSuccess = false;
				});
		},
	},
};
</script>
